import { styled } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

const TicketAdvancedLayout = styled(Paper)({
    height: `calc(100vh - 48px)`,
    display: "flex",
    flexDirection: "column"
})

export default TicketAdvancedLayout;